"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const theme = {
  background: 'field.1',
  backgroundActive: 'interactive.ui.active',
  backgroundDisabled: 'disabled.1',
  backgroundHover: 'interactive.ui.hover',
  borderRadius: 100,
  color: 'text.body',
  fontWeight: 'bold',
  height: 32,
  padding: ['none', 'xxlarge', 'none', 'medium'],
  textStyle: 'meta'
};
exports.theme = theme;
//# sourceMappingURL=Select.theme.js.map